var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.targetedPromotionLabel)?_c('div',{staticClass:"promo-code",attrs:{"data-testId":"sbx-pcs-productPromoCode"}},[_c('p',{staticClass:"promo-code__text"},[_c('VoucherSvg'),_vm._v(" "+_vm._s(_vm.targetedPromotionLabel)+" ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }